function sendLeadToCRM(productName) {
  fetch("https://backend-service-xady.onrender.com/api/leads/shopify", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
    source: "shopify",
    action: "whatsapp_product",
    lead_source_label: "Product Page WhatsApp",
    product: productName,
    product_url: window.location.href,
    page_url: window.location.href,
    lead_type: "product_inquiry",
    priority: "warm",
    timestamp: new Date().toISOString()
    })
  });
}

function handleWhatsAppClick(event, productTitle) {
  // DO NOT prevent default (let href work naturally)

  // Prevent duplicate
  if (event.currentTarget.dataset.crmTracked) return;
  event.currentTarget.dataset.crmTracked = "true";

  sendLeadToCRM(productTitle);
}

// Auto-capture ALL WhatsApp clicks (FINAL CLEAN VERSION)
document.addEventListener("DOMContentLoaded", function () {

  document.body.addEventListener("click", function(e) {

    const link = e.target.closest('a[href*="wa.me"]');
    if (!link) return;

    // Skip if already handled (product button)
    if (link.dataset.crmTracked) return;

    link.dataset.crmTracked = "true";


    let productName =
      document.querySelector("h1")?.innerText ||
      document.title ||
      "Website Inquiry";

    sendLeadToCRM(productName);

  });

});